import { Object3D, Object3DEventMap } from 'three';

/**
 * Listen to changes in the object and its children
 */
export const listenObjectChanges = (
  node: Object3D,
  addedNode: (node: Object3D) => void,
  removedNode: (evt: Object3D) => void = () => {}
) => {
  const handleChildAdded = (evt: Object3DEventMap['childadded']) => {
    evt.child.traverse((node) => {
      node.addEventListener('childadded', handleChildAdded);
      node.addEventListener('childremoved', handleChildRemoved);
      addedNode(node);
    });
  };

  const handleChildRemoved = (evt: Object3DEventMap['childremoved']) => {
    evt.child.traverse((node) => {
      node.removeEventListener('childadded', handleChildAdded);
      node.removeEventListener('childremoved', handleChildRemoved);
      removedNode(node);
    });
  };

  handleChildAdded({ child: node });

  return () => {
    node.removeEventListener('childadded', handleChildAdded);
    node.removeEventListener('childremoved', handleChildRemoved);
  };
};
